<template>
  <nav id="invites-footer-nav" class="invites-footer p-10 w-full">
    <ul class="nav-list w-full flex justify-end aisea-text-14-400-black gap-12">
      <li>
        <a
          :href="urlTermsOfService"
          target="_blank"
          rel="noopener noreferrer"
          >{{ messages.nav.termsOfService }}</a
        >
      </li>
      <li>
        <a :href="urlPryvacyPolicy" target="_blank" rel="noopener noreferrer">{{
          messages.nav.privacyPolicy
        }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
const MESSAGES = {
  nav: {
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
  },
};
const URL_TERMS_OF_SERVICE = "https://aisea.net/aisea-pro-terms/";
const URL_PRYVACY_POLICY = "https://aisea.net/privacy_policy/";

export default {
  name: "InvitesFooter",
  mixins: [],
  props: {
    urlTermsOfService: { type: String, default: URL_TERMS_OF_SERVICE },
    urlPryvacyPolicy: { type: String, default: URL_PRYVACY_POLICY },
    messages: { type: Object, default: () => MESSAGES },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#invites-footer-nav.invites-footer {
  .nav-list {
    > li {
      position: relative;
      &:not(:first-child)::before {
        content: "";
        display: inline-block;
        position: absolute;
        left: -21px;
        width: 1.25px;
        height: 15px;
        background-color: $aisea-mouse-gray;
      }
    }
    a:visited {
      color: unset;
    }
    a:active,
    a:hover {
      color: rgba(var(--vs-primary), 1);
    }
  }
}
</style>
